import React, { useRef, useEffect, useState  } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalVideo } from 'reduxx/actions/partials/modals/modalVideo';
import useOutsideClick from './hooks/useOutsideClick'; 
import { classNames } from "utils/classNames";
import modalStoryStyles from 'styles/css/ModalStoryStyles.module.scss';


const ModalVideo = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, story } = useSelector(state => state.modalVideo);


	const videoRef = useRef(null);
  	const [progress, setProgress] = useState(0);
  	const [time, setTime] = useState("00:00");

	const handleClose = () => {
		dispatch(handleChangeDataModalVideo('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalVideo('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalVideo]);


  	// تبدیل ثانیه به mm:ss
  	const formatTime = (seconds) => {
	    if (isNaN(seconds)) return "00:00";
	    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
	    const s = Math.floor(seconds % 60).toString().padStart(2, "0");
	    return `${m}:${s}`;
  	};


  	useEffect(() => {
  		if (!isActive) return;

	    const video = videoRef.current;
	    if (!video) return;

	    const updateProgress = () => {
	      	const percent = (video.currentTime / video.duration) * 100;
	      	setProgress(percent);
	      	setTime(formatTime(video.currentTime));
	    };

	    video.addEventListener("timeupdate", updateProgress);
	    return () => {
	      	video.removeEventListener("timeupdate", updateProgress);
	    };
  	}, [isActive, story]);

  	if (!isActive || !story) return null;



	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };




    return (

		<div ref={outerRef} className={classNames(modalStoryStyles['ReactModal__Overlay'], isActive && modalStoryStyles['ReactModal__Overlay--after-open'])} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.8)', zIndex: '11'}}>
			<div ref={centerBoxRef} className={classNames(modalStoryStyles['ReactModal__Content'], modalStoryStyles['ReactModal__Content--after-open'], modalStoryStyles.relative, modalStoryStyles['w-fit'], modalStoryStyles['lg:px-20'], modalStoryStyles['mx-auto'], modalStoryStyles.flex, modalStoryStyles['justify-center'], modalStoryStyles['items-center'], modalStoryStyles['flex-row'])} tabIndex="-1" role="dialog" aria-modal="true" >

				{ !isMobile &&
					<div className={classNames(modalStoryStyles['my-auto'], modalStoryStyles['p-2'], modalStoryStyles['rounded-circle'], modalStoryStyles['border-complete'], modalStoryStyles.absolute, modalStoryStyles['bottom-0'], modalStoryStyles['top-0'], modalStoryStyles['m-auto'], modalStoryStyles['h-max'], modalStoryStyles['bg-neutral-000'], modalStoryStyles['cursor-pointer'], modalStoryStyles['styles_left__9JtiE'])}>
						<div className={classNames(modalStoryStyles.flex)}>
							<svg style={{width: '24px', height: '24px', fill: '#fff'}}><use xlinkHref="#chevronLeft" /></svg>
						</div>
					</div>
				}

				<div className={classNames(modalStoryStyles['grow-0'], modalStoryStyles['lg:w-90'], modalStoryStyles['w-screen'])} style={{height: '576.65px'}}>
					<div className={classNames(modalStoryStyles['w-full'], modalStoryStyles['h-full'], modalStoryStyles.flex, modalStoryStyles['flex-col'])}>
						<div className={classNames(modalStoryStyles['w-full'], modalStoryStyles['h-30'], modalStoryStyles.relative, modalStoryStyles['flex-1'])}>
							<div className={classNames(modalStoryStyles.absolute, modalStoryStyles['top-0'], modalStoryStyles['left-0'], modalStoryStyles['right-0'], modalStoryStyles['h-20'], modalStoryStyles['z-1'], modalStoryStyles['styles_VideoModalContentHeaderOverlay'])} ></div>
							<div className={classNames(modalStoryStyles.absolute, modalStoryStyles['top-0'], modalStoryStyles['left-0'], modalStoryStyles['right-0'], modalStoryStyles['z-2'], modalStoryStyles['px-5'], modalStoryStyles['pt-4'], modalStoryStyles.flex, modalStoryStyles['justify-between'], modalStoryStyles['items-center'], modalStoryStyles['w-full'])}>
								<div className={classNames(modalStoryStyles.flex, modalStoryStyles['items-center'])}>
									<div onClick={handleClose} className={classNames(modalStoryStyles['flex'], modalStoryStyles['cursor-pointer'])} style={{cursor: 'pointer'}}>
										<svg style={{width: '24px', height: '24px', fill: '#fff'}}><use xlinkHref="#arrowRight" /></svg>
									</div>
								</div>
							</div>

							<div className={classNames(modalStoryStyles['w-full'], modalStoryStyles['h-full'], modalStoryStyles.relative)}>
								<div className={classNames(modalStoryStyles.flex, modalStoryStyles['items-center'], modalStoryStyles['justify-center'])}>
									<div className={classNames(modalStoryStyles.flex, modalStoryStyles['items-center'], modalStoryStyles['justify-around'], modalStoryStyles.absolute, modalStoryStyles['inset-0'], modalStoryStyles['mx-auto'], modalStoryStyles['my-auto'], modalStoryStyles['z-[-1]'])} style={{width: '24px', height: '24px'}}>
										<div className={classNames(modalStoryStyles['rounded-circle'], modalStoryStyles['styles_Loading__circle1__K7HNJ'])} style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} ></div>
										<div className={classNames(modalStoryStyles['rounded-circle'], modalStoryStyles['styles_Loading__circle2__jpl_q'])} style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} ></div>
										<div className={classNames(modalStoryStyles['rounded-circle'], modalStoryStyles['styles_Loading__circle3__otcH4'])} style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} ></div>
									</div>
								</div>
								<div style={{width: '100%', height: '100%'}}>
									<video ref={videoRef} preload="auto" autoPlay loop disablePictureInPicture={true} playsInline webkit-playsinline="true" x5-playsinline="true" src={story.video} className={classNames(modalStoryStyles['w-full'], modalStoryStyles['h-full'])} />
								</div>
							</div>

							<div className={classNames(modalStoryStyles.flex, modalStoryStyles['flex-col'], modalStoryStyles['px-5'], modalStoryStyles.absolute, modalStoryStyles['bottom-0'], modalStoryStyles['right-0'], modalStoryStyles['left-0'], modalStoryStyles['z-2'])}>
								<div className={classNames(modalStoryStyles.absolute, modalStoryStyles['inset-0'], modalStoryStyles['z-0'], modalStoryStyles['styles_VideoModalContentFooterOverlay'])} ></div>
								<div className={classNames(modalStoryStyles['z-1'])}>
									<div className={classNames(modalStoryStyles.flex, modalStoryStyles['items-end'], modalStoryStyles['justify-between'], modalStoryStyles['lg:gap-2'], modalStoryStyles['gap-4'])}>
										<div className={classNames(modalStoryStyles.relative, modalStoryStyles['h-full'])}>
											<div className={classNames(modalStoryStyles.relative)}>
												<h5 className={classNames(modalStoryStyles['text-h5'], modalStoryStyles['text-neutral-100'])}>{story.title}</h5>
												<div className={classNames(modalStoryStyles['text-body-1'], modalStoryStyles['mb-1'], modalStoryStyles['text-neutral-100'], modalStoryStyles['ellipsis-2'])} ></div>
												<p className={classNames(modalStoryStyles['text-body-1'], modalStoryStyles['mb-1'], modalStoryStyles.absolute, modalStoryStyles['w-full'], modalStoryStyles['text-neutral-100'], modalStoryStyles['styles_shadowPostCaption__S8Xv_'])} />
											</div>
										</div>
										<div className={classNames(modalStoryStyles.flex, modalStoryStyles['gap-4'], modalStoryStyles['flex-col'])} ></div>
									</div>

									<div className={classNames(modalStoryStyles['w-full'], modalStoryStyles['pt-4'], modalStoryStyles['pb-3'], modalStoryStyles.flex, modalStoryStyles['items-center'], modalStoryStyles['justify-between'], modalStoryStyles['gap-1'])}>
										<div className={classNames(modalStoryStyles['w-full'], modalStoryStyles['h-1'], modalStoryStyles['bg-gray-600'], modalStoryStyles['rounded-full'], modalStoryStyles['overflow-hidden'], modalStoryStyles['ml-2'])} style={{direction: "ltr"}}>
											<div className={classNames(modalStoryStyles['h-full'], modalStoryStyles['bg-white'], modalStoryStyles['transition-all'], modalStoryStyles['duration-200'])} style={{ width: `${progress}%` }} ></div>
										</div>
										<p className={classNames(modalStoryStyles['text-white'], modalStoryStyles['text-caption-strong'], modalStoryStyles['w-12'], modalStoryStyles['text-left'])}>{toPersianDigits(time)}</p>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				{ !isMobile &&
					<div className={classNames(modalStoryStyles['my-auto'], modalStoryStyles['p-2'], modalStoryStyles['rounded-circle'], modalStoryStyles['border-complete'], modalStoryStyles.absolute, modalStoryStyles['bottom-0'], modalStoryStyles['top-0'], modalStoryStyles['m-auto'], modalStoryStyles['h-max'], modalStoryStyles['bg-neutral-000'], modalStoryStyles['cursor-pointer'], modalStoryStyles['styles_right__bWd56'])}>
						<div className={classNames(modalStoryStyles.flex)}>
							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}><use xlinkHref="#chevronRight" /></svg>
						</div>
					</div>
				}

			</div>
		</div>



        
    );
}

export default ModalVideo;
